<script setup lang="ts">
import {
  AtomLoadingSpinner,
  AtomText,
  SatButton,
} from "@chatfood/design-system";
import { bemBuilder } from "@chatfood/core-utils";
import { ref } from "vue";
import { useModalHubStore } from "../modal-hub";
import { useLocale } from "~/composables/use-locale";
import { CrossSellItems } from "~/components/cross-sell-items";

import { useNavigation } from "~/composables/use-navigation";

const css = bemBuilder("cross-sell-list");

const { t } = useLocale();
const modalHub = useModalHubStore();
const { push } = useNavigation();

const onCheckout = async () => {
  await push("checkout", {});
  modalHub.hideCrossSellList();
};

const isLoading = ref(true);

const onCrossellReady = (hasItems: boolean) => {
  if (hasItems) {
    isLoading.value = false;
    return;
  }

  onCheckout();
};
</script>

<template>
  <div :class="css('')">
    <AtomText type="subtitle" tag="div">
      {{ t("components.cross_sell_list.title") }}
    </AtomText>
    <div :class="css('content')">
      <AtomLoadingSpinner v-if="isLoading" :class="css('loading')" />
      <CrossSellItems view="column" @has-items="onCrossellReady" />
      <div :class="css('cta')">
        <SatButton
          theme="filled"
          variant="primary"
          wide
          size="large"
          data-test="checkout-button"
          @click="onCheckout"
        >
          {{ t("components.cross_sell_list.cta") }}</SatButton
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cross-sell-list {
  width: 576px;
  max-width: 100%;
  display: flex;
  gap: var(--spacing-lg);
  flex-direction: column;
  padding: var(--spacing-lg);

  @media (width > $breakpoint-sm) {
    max-height: 90vh;
    padding-bottom: var(--spacing-lg);
  }

  &__content {
    position: relative;

    @media (width > $breakpoint-sm) {
      overflow: auto;
      max-height: 90vh;
      padding-block: 0;
      margin-block: 0;
    }
  }

  &__cta {
    background-color: var(--color-base-100);
    position: sticky;
    bottom: 0;
    left: 0;
    padding-top: var(--spacing-lg);
  }

  &__loading {
    margin: 0 auto;
    display: flex;
  }
}
</style>
